import reportesService from "../../services/reportes";
import { Refresh } from "../../services/refreshToken";
import dayjs from "dayjs";
import store from "../index.js";
export default {
  namespaced: true,
  state: {
    // state de movimientos
    reversiones: [],
    rendicionesTotales: [],
    rendicionesDetalle: {
      Rendiciones: [],
      Ajustes: [],
      Devoluciones: [],
    },
    fechaConsideracion: [],
    showCostoFinancieroPreview: false,
    showSplit: false,

    //  filter fechas inicio y fin
    fechaInicio: dayjs().subtract(1, "weeks").format("YYYY-MM-DD"),
    fechaFin: dayjs().format("YYYY-MM-DD"),

    cargarPagoItems: false,

    //  numero de pagina y total de registros
    page: 1,
    total: 0,
    visible: 7,

    // numero de registro por pagina
    rowsPerPage: 50,

    //loading en peticiones
    loading: false,
    loadingDetalles: false,

    //menu
    menu1: false,
    menu2: false,

    //errores de api
    errored: false,
    error: false,
  },

  mutations: {
    // mutations movimientos
    setReversiones(state, reversiones) {
      state.reversiones = reversiones;
    },

    setRendicionesTotales(state, rendicionesTotales) {
      state.rendicionesTotales = rendicionesTotales;
    },

    setRendicionesDetalle(state, rendicionesDetalle) {
      state.rendicionesDetalle = rendicionesDetalle;
    },

    setFechaConsideracion(state, fechaConsideracion) {
      state.fechaConsideracion = fechaConsideracion;
    },

    setShowCostoFinancieroPreview(state, value) {
      state.showCostoFinancieroPreview = value;
    },

    setShowSplit(state, value) {
      state.showSplit = value;
    },

    setPaginate(state, value) {
      state.page = value;
    },

    setTotal(state, value) {
      state.total = value;
    },
    setrowsPerPage(state, value) {
      state.rowsPerPage = value;
    },
    setLoading(state, value) {
      state.loading = value;
    },

    setLoadingDetalles(state, value) {
      state.loadingDetalles = value;
    },

    setErrord(state, value) {
      state.errored = value;
    },

    setFechaInicio(state, value) {
      state.fechaInicio = value;
    },

    setFechaFin(state, value) {
      state.fechaFin = value;
    },

    setCargarPagoItems(state, value) {
      state.cargarPagoItems = value;
    },

    setMenu1(state, value) {
      state.menu1 = value;
    },

    setMenu2(state, value) {
      state.menu2 = value;
    },
  },

  actions: {
    async setFechaInicio({ commit }, fecha) {
      commit("setFechaInicio", fecha);
    },
    async setFechaFin({ commit }, fecha) {
      commit("setFechaFin", fecha);
    },

    async setCargarPagoItems({ commit }, value) {
      commit("setCargarPagoItems", value);
    },

    async setLoading({ commit }, value) {
      commit("setLoading", value);
    },

    async setShowCostoFinancieroPreview({ commit }, value) {
      commit("setShowCostoFinancieroPreview", value);
    },

    async setShowSplit({ commit }, value) {
      commit("setShowSplit", value);
    },

    async getReversiones({ commit, rootState, state }) {
      const params = {
        FechaInicio: dayjs(state.fechaInicio).format("DD-MM-YYYY"),
        FechaFin: dayjs(state.fechaFin).format("DD-MM-YYYY"),
        ClienteId: rootState.cliente_ID,
        CuentaId: rootState.cuenta_ID,
        CargarPagoItems: state.cargarPagoItems,
      };

      commit("setErrord", false);
      commit("setLoading", true);

      const request = rootState.split_cuenta
        ? reportesService.reporteReversionesSplit(params)
        : reportesService.reporteReversiones(params);

      request
        .then((response) => {
          if (response?.data?.DetallesReversiones == null) {
            commit("setReversiones", []);
            commit("setPaginate", 1);
            commit("setTotal", 0);
            commit("setLoading", false);
          } else {
            // si la consulta es distinto de null se actualiza el store mutations movimientos
            commit("setReversiones", response?.data?.DetallesReversiones);
            commit("setPaginate", response.data.meta.page.currentPage);
            commit("setTotal", response.data.meta.page.lastPage);
          }
          this.$toast.error("Error de conexión. Intenta nuevamente.");
        })
        .catch((error) => {
          if (error.response) {
            var data = error.response.status;
          } else {
            commit("setErrord", true);
          }
        })
        .finally(() => commit("setLoading", false));
    },

    async getRendicionesTotales({ commit, dispatch }, params = {}) {
      const { _retried = false, ...queryParams } = params;
      commit("setErrord", false);
      commit("setLoading", true);
      reportesService
        .reporteRendicionesTotales(queryParams)
        .then((response) => {
          if (response?.data == null) {
            commit("setRendicionesTotales", []);
            commit("setPaginate", 1);
            commit("setTotal", 0);
            commit("setLoading", false);
          } else {
            // si la consulta es distinto de null se actualiza el store mutations movimientos
            commit("setRendicionesTotales", response?.data.Rendiciones);
            commit(
              "setFechaConsideracion",
              response?.data.FechasConsideraciones,
            );
            // commit("setPaginate", response.data.meta.page.currentPage);
            // commit("setTotal", response.data.meta.page.lastPage);
          }
        })
        .catch(async (error) => {
          if (error.response?.status === 403 && !_retried) {
            try {
              await Refresh.getRefreshToken();
              return await dispatch("getRendicionesTotales", { ...queryParams, _retried: true });
            } catch (refreshError) {
              commit("setRendicionesTotales", []);
              commit("setFechaConsideracion", []);
              commit("setPaginate", 1);
              commit("setTotal", 0);
              store.commit("logout");
            }
          } else if (error.response?.status === 403 && _retried) {
            commit("setRendicionesTotales", []);
            commit("setFechaConsideracion", []);
            commit("setPaginate", 1);
            commit("setTotal", 0);
            store.commit("logout");
          } else {
            commit("setErrord", true);
          }
        })
        .finally(() => commit("setLoading", false));
    },

    async getRendicionesDetalles(
      { commit, rootState, state, dispatch },
      { general = false, fecha, _retried = false } = {},
    ) {
      const params = {
        Fecha: general ? dayjs(state.fechaInicio).format("DD-MM-YYYY") : fecha,
        FechaFin: general ? dayjs(state.fechaFin).format("DD-MM-YYYY") : fecha,
        CuentaId: rootState.cuenta_ID,
      };

      commit("setErrord", false);
      commit("setLoadingDetalles", true);
      try {
        const response = await reportesService.reporteRendicionesDetalles(
          params,
        );
        const detalles = response?.data?.DetallesRendiciones ?? [];
        // si es individual, actualizás el store para el preview
        if (!general) {
          commit(
            "setRendicionesDetalle",
            detalles?.[0] ?? { Rendiciones: [], Ajustes: [], Devoluciones: [] },
          );
        }
        return detalles;
      } catch (error) {
        if (error.response?.status === 403 && !_retried) {
          try {
            await Refresh.getRefreshToken();
            return await dispatch("getRendicionesDetalles", { general, fecha, _retried: true });
          } catch (refreshError) {
            commit("setRendicionesDetalle", {
              Rendiciones: [],
              Ajustes: [],
              Devoluciones: [],
            });
            store.commit("logout");
            return [];
          }
        }
        if (error.response?.status === 403 && _retried) {
          commit("setRendicionesDetalle", {
            Rendiciones: [],
            Ajustes: [],
            Devoluciones: [],
          });
          store.commit("logout");
          return [];
        }
        commit("setErrord", true);
        return [];
      } finally {
        commit("setLoadingDetalles", false);
      }
    },
  }, // Fin de actions

  getters: {
    fechaInicio: (state) => state.fechaInicio,
    fechaFin: (state) => state.fechaFin,
    cargarPagoItems: (state) => state.cargarPagoItems,
    pages: (state) => state.page,
    total: (state) => state.total,
    rowsPerPage: (state) => state.rowsPerPage,
    loading: (state) => state.loading,
    loadingDetalles: (state) => state.loadingDetalles,
    errored: (state) => state.errored,
    error: (state) => state.error,
    rendiciones: (state) => state.rendicionesTotales,
    fechaConsideracion: (state) => state.fechaConsideracion,
    rendicionesDetalle: (state) => state.rendicionesDetalle,
    showCostoFinancieroPreview: (state) => state.showCostoFinancieroPreview,
    showSplit: (state) => state.showSplit,
    reversiones: (state) => state.reversiones,
  },

  modules: {},
};
